import { render, staticRenderFns } from "./AppScoreSection.vue?vue&type=template&id=2fd39d2c&scoped=true"
import script from "./AppScoreSection.vue?vue&type=script&lang=js"
export * from "./AppScoreSection.vue?vue&type=script&lang=js"
import style0 from "./AppScoreSection.vue?vue&type=style&index=0&id=2fd39d2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd39d2c",
  null
  
)

export default component.exports